<template>
  <section class="laboratory">
      <div class="laboratory__content container">
				<h2 class="laboratory__title --fade-in-down --delay-1" data-vertical-ivp-class="--animate">Select Onassis Holding Corp Products/Brands</h2>
				<div class="laboratory__info-container">
					<img class="laboratory__side-img --fade-in-right --delay-1" data-vertical-ivp-class="--animate" src="../assets/laboratory/ananda-pic.png" alt="Ananda product image">
					<div class="laboratory__description --fade-in-left --delay-1" data-vertical-ivp-class="--animate">
						<img class="laboratory__text-logo"  src="../assets/laboratory/anandalab-logo.png" alt="Ananda product logo">
						<img class="laboratory__side-img-mobile" src="../assets/laboratory/ananda-pic.png" alt="Ananda product image">
						<div>
							<p>
							Skincare products comprise a massive piece of the health and wellness pie, 
							accounting for $213 billion globally by 2028 and registering a CAGR of 9.2%, 
							<a class="text-link" href="https://www.prnewswire.com/news-releases/skincare-products-market-size-worth-213-3bn-globally-by-2028-at-9-2-cagr---exclusive-report-by-the-insight-partners-301509792.html" target="_blank">according to Grandview Research.</a>  
							</p>
							<p>
							Ananda Labs is a versatile company that specializes in CBD-based skincare products. The company 
							develops a variety of products under its label, including CBD Stem Cells & Peptides Eye Contour Cream, 
							CBD Concealer Repair Cream, CBD & Hyaluronic Facial PH Balance Toner, CBD & Hyaluronic Cleansing Milk, and more. 
							</p>
							<p>
							The company also oversees marketing operations of Extrax CBD vapes. The product provides 
							broad-spectrum CBD Hemp extract combined with Cannabis derived terpenes, in high-quality 
							vaping devices, without any stabilizers or additives of any sort, branded as a leading product 
							for the "vaping smart" trend.
							</p>
							<a class="text-link" href="https://www.onassis-holdings.com/ananda/" target="_blank">Learn More About Ananda</a>
						</div>
					</div>
				</div>
				<div class="laboratory__info-container">
					<div class="laboratory__description  --fade-in-right --delay-1" data-vertical-ivp-class="--animate">
						<img class="laboratory__text-logo" src="../assets/laboratory/mgc-logo.png" alt="MGC product logo">
						<img class="laboratory__side-img-mobile" src="../assets/laboratory/mgc-pic.png" alt="Leaf sample">
						<div>
							<p>
							MGC Nutra is a subsidiary of Onassis which focuses on plant-based medicines, 
							such as ArtemiC product line. The nutraceuticals market was <a class="text-link" href="https://www.globenewswire.com/en/news-release/2022/03/24/2409459/28124/en/Global-Nutraceuticals-Market-2021-to-2026-by-Type-Application-Health-Benefits-Form-and-Geography.html#:~:text=The%20Global%20Nutraceuticals%20Market%20is,at%20a%20CAGR%20of%2010.23%25.&text=The%20key%20factor%20driving%20the,the%20U.S.%20on%20which%2089%25" target="_blank">reportedly worth $224 
							billion back in 2021 and expected to reach $365 billion by 2026 thanks to its CAGR of 10.23%.</a> 
							</p>
							<p>
							MGC Nutra focuses on creating high-grade CBD products that can be used for overall wellness, 
							such as water soluble supplements, pods, and more. MGC’s specific approach is to bring pharma 
							standards to this relatively new CBD and nutraceuticals market, and it shares scientific information 
							behind its research into CBD’s effectiveness and development of their products. 
							</p>
							<a class="text-link" href="https://mgcnutra.com/about-company-en/" target="_blank">Learn More About MGC Nutra</a>
						</div>
					</div>
					<img class="laboratory__side-img --fade-in-left --delay-1" data-vertical-ivp-class="--animate" src="../assets/laboratory/mgc-pic.png" alt="Leaf sample">
				</div>
				<div class="button-container">
					<a class="primary-button --fade-in-up --delay-1" data-vertical-ivp-class="--animate" href="#">Invest Now</a>
				</div>
      </div>
  </section>
</template>

<script>
export default {
  name: 'Laboratory',
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/laboratory.scss";
</style>
